<template>
    <div :id="appId" class="datacycle-widget vld-parent">
        <loading :active.sync="isLoading" :is-full-page="false"></loading>
        <div>
            <dc-map
                    :apiHost="apiHost"
                    :apiEndpoint="apiEndpoint"
                    :map-width="mapWidth"
                    :map-height="mapHeight"
                    :map-type="mapType"
                    :locale="lang"
            ></dc-map>
            <dc-topbar v-if="!isSimple"></dc-topbar>
            <dc-sidebar v-if="!isSimple" :locale="lang"></dc-sidebar>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import qs from 'qs';
    import 'mapbox-gl/dist/mapbox-gl.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import {initializeDefault} from '../services/data.service';
    import dcUtilities from "../utilities/dc.utility";
    import settings from '../settings/settings';
    import mapType from '../types/mapType';

    import '../directives/outsideclick.directive';
    /**
     * side note. The components are named like this on purpose.
     * the IDE will only display the name of the file and if you are editing multiple index.js files it can get confusing...
     */
    import '../components/dc-map/dc-map';
    import '../components/dc-card/dc-card';
    import '../components/dc-popup/dc-popup';
    import '../components/dc-list/dc-list';
    import '../components/dc-sidebar/dc-sidebar';
    import '../components/topbar/dc-search/dc-search';
    import '../components/topbar/dc-category-filter/dc-category-filter';
    import '../components/topbar/dc-topbar/dc-topbar';

    /*
    import '../components/detail/dc-detail/dc-detail';
    import '../components/detail/dc-subdetail-container/dc-subdetail-container';
    import '../components/detail/dc-detail-offers/dc-detail-offers';
    import '../components/detail/dc-detail-tour/dc-detail-tour';
    //*/

    axios.defaults.paramsSerializer = params => {
        return qs.stringify(params, { encode: true, arrayFormat: 'brackets' });
    };

    export default {
        components: {
            Loading
        },
        props: {
            apiHost: {
                type: String,
                default: settings.dc.apiHost
            },
            apiEndpoint: {
              type: String,
              default: settings.dc.apiEndpoint
            },
            lang: {
                type: String,
                default: ''
            },
            appId: {
                type: String,
                default: 'dataCycle-widget'
            },
            mapWidth: {
                type: String,
                default: '100%'
            },
            mapHeight: {
                type: String,
                default: '600px'
            },
            mapZoom: {
                type: Number,
                default: 5
            },
            mapLon: {
                type: Number,
                default: 12.2
            },
            mapLat: {
                type: Number,
                default: 48.4
            },
            markerHeight: {
                type: Number,
                default: 44
            },
            mapType: {
                type: String,
                default: ''
            },
            featureId: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                dataService: {}
            };
        },
        computed: {
            isLoading: {
                get(){
                    return this.$store.getters.isLoading;
                },
                set(newValue){
                    this.$store.commit('setIsLoading',newValue);
                }
            },
            isSimple(){
                return this.mapType == mapType.simple && !!this.featureId;
            }
        },
        created() {},
        mounted() {
            //debugger;

            if(!this.lang){
                this.lang = this.loadLocaleFromGetParameters('de');
            }

            this.$i18n.locale = this.lang;
            this.$store.commit('setAppId',this.appId);
            this.$store.commit('setMapType', this.mapType);
            this.$store.commit('setFeatureId', this.featureId); //we set the feature Id, it does not matter if it is empty or not

            this.dataService = initializeDefault(this.apiHost, this.apiEndpoint, this.lang);

            let getParameters = this.loadGetParameters();

            if(!this.isSimple) {
                this.loadCategories();
                if(!!getParameters.id)
                    this.loadInitial(getParameters.id);
            }
            if(this.isSimple){
                this.loadFeature(this.featureId);
            }
        },
        methods: {
            loadCategories(){
                this.$store.commit('setCategories', settings.dc.categories.map(category => {
                    category.subcategories = [];
                    return category;
                }));
                const dataService = initializeDefault(this.apiHost, this.apiEndpoint);
                let storedCategories = this.$store.getters.categories;
                storedCategories.map(category => {
                    dataService.loadCategoryTree(category.id).then((subcategories) => {
                        category.subcategories = subcategories.filter(subcategory => {
                        	if(subcategory.translations){
                        		return subcategory.translations.includes(this.$i18n.locale);
                            }
                        	return false;
                        });
                    });
                });
            },
            loadLocaleFromGetParameters(defaultLocale){
            	let locale = defaultLocale || 'de';
	            if(!!window.location.search){
		            var urlParams = new URLSearchParams(window.location.search);
		            if(urlParams.has('lang')){
			            locale = urlParams.get('lang');
		            }
	            }
	            return locale;
            },
            loadGetParameters(){
                let parameters = {};
                if(!!window.location.search){
                    var urlParams = new URLSearchParams(window.location.search);
                    if(urlParams.has('id')){
                        parameters.id = urlParams.get('id');
                    }
                }
                return parameters;
            },
            loadInitial(featureId){
                this.dataService.loadSingle(featureId).then(feature => {
                    this.$store.commit("setInitialFeaturesList", [feature]);
                    this.$store.commit('setIsLoading', false);
                }).catch(err => {
                    console.log(err);
                });
            },
            loadFeature(featureId){
                this.dataService.loadSingle(featureId).then(feature => {
                    this.$store.getters.contents.data = [feature];
                    let tour = _.get(feature, 'details[0].tour', null);
                    if(!!tour){
                        const trip = dcUtilities.convertTripToTile(feature);
                        this.setActiveFeature(trip);
                    }
                    this.$store.commit('setIsLoading', false);
                });
            },
            setActiveFeature(trip){
                setTimeout(() => {
                    this.$store.commit('setActiveTrip', trip);
                },1000);
            }
        },
        watch: {}
    };
</script>
